<template>
  <view class="w-full mt-20px flex flex-col justify-center items-center">
    <img class="w-150px mb-20px" src="@/static/images/common/empty.png" alt="" mode="widthFix" />
    <view class="text-navigate-menuTextColor">{{ content || $t('common.empty') }}</view>
  </view>
</template>

<script setup lang="ts">
import { reactive } from 'vue'
const props = defineProps<{
  content?: string
}>()
</script>

<script lang="ts">
export default {
  name: 'Empty',
}
</script>

<style lang="scss" scoped></style>
